import { trackEvent } from '../../../utils/analytics/analytics';
import type { PlusEvent, PlusEventName, PlusUsedFeature } from '../../../types/analytics-events';

/** Fires one of the Plus funnel events (spec 9) through the shared analytics pipeline. */
export function trackPlus(event: PlusEventName, props: PlusEvent['params'] = {}): void {
  try {
    trackEvent({ name: event, params: props });
  } catch {
    // Analytics must never break a purchase flow.
  }
}

/**
 * Round 3 and 4: the one `plus_<feature>_used` event a feature fires when a member actually uses it
 * (docs/plus-round3-conventions.md). Fire it once per use, from the client after the action
 * succeeded; limit hits are not this event (they go through the meter as `plus_limit_reached`).
 */
export function trackPlusUsed(feature: PlusUsedFeature, props: PlusEvent['params'] = {}): void {
  trackPlus(`plus_${feature}_used` as PlusEventName, { feature, ...props });
}
